import React from "react";
import "./styles.scss";
import "./mobile.scss";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      <div
        className={`form-header-wrapper ${data.size} ${data.mainLayerStyles} ${data.lan} ${data.textAlign}`}
        onClick={onClick}
      >
        <h2>{data.formHeader}</h2>
      </div>
    </>
  );
  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultdata = {};

export default Index;
